// extracted by mini-css-extract-plugin
export default {"skipToContent":"skip_to_content-module___skipToContent___e0d1fd9a"};